module.exports = __webpack_public_path__ + "static/media/home_icon_store.cec4a653.png";